import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { AreaTextPipe } from '@bo-client/shared/pipes/area-text.pipe';
import { DatePipe } from '@angular/common';
import { MetaService } from '@bo-client/core/api/meta-service';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-comment-modal',
  templateUrl: './confim-with-comment-modal.component.html',
  styleUrls: ['./confim-with-comment-modal.component.scss']
})
export class ConfimWithCommentModalComponent implements OnInit {
  public comment = '';
  public commentRequested: string = null;
  public subject = '';
  public actionName = '';
  public recipients = '';

  constructor(
    public dialogRef: MatDialogRef<ConfimWithCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionWithMoreInfoModel,
    protected toastService: ToastrService
  ) {}

  ngOnInit() {
    const datePipe = new DatePipe('de-DE');
    this.actionName = this.data.actionName;
    this.recipients = this.data.recipients;
    this.subject = this.data.subject;
    this.commentRequested = this.data.commentRequested;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    if (!this.comment && this.commentRequested) {
      this.toastService.error('Bitte begründen Sie diese Aktion');
      return;
    }
    this.data.subject = this.subject;
    this.data.comment = this.comment;

    this.dialogRef.close(this.data);
  }
}
